import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { VirtualFolderNode } from 'src/app/_models/virtualFolder';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { MatTableDataSource } from '@angular/material/table';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { MatDialogRef } from '@angular/material/dialog';
import { AppConfig } from 'src/assets/config/config/app-config';
import { S3 } from 'aws-sdk';
import { formatDate } from '@angular/common';
import { DocumentService } from 'src/app/_services/document.services';
import { AlertService } from 'src/app/_services/alert.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import { FileInboxVirtualFolderService } from 'src/app/_services/fileInbox-virtualFolder.service';
import { first } from 'rxjs/internal/operators/first';
import { MigrationService } from 'src/app/_services/document-migration.services';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { Stack } from 'src/app/_helpers/custom-stack';

interface FolderFlatNode {
  expandable: boolean;
  id: number;
  folder_name: string;
  parent_id: number;
  level: number;
}


@Component({
  selector: 'app-duplicate',
  templateUrl: './duplicate.component.html',
  styleUrls: ['./duplicate.component.scss']
})
export class DuplicateComponent implements OnInit {
  fileUploaded: boolean = false;
  displayedColumns: string[] = ['Folders', 'Documents'];
  duplicatedColumns: string[] = ['documentName', 'createDate', 'createdBy', 'filesize', 'isMigrateToECM'];
  azureHeader: any  
  dupDocList: MatTableDataSource<any>;
  docId: string;
  isFile: boolean = false;
  fileToUpload: FileList = null;
  filesToUpload: FileList[] = null;
  progressInfos = [];
  uploadedFiles = [];  
  fileInfos: Observable<any>;
  selection = new SelectionModel<any>(true, []);
  message = '';
  documents: any;
  totalDocumentCount: number = 0;
  offset: number = 0;
  selectedDoc: String;
  loadNext: boolean = false;
  loadPrevious: boolean = false;
  documentCount: number = 0;  
  folderSelected: boolean = false;
  refreshClue: any = null;
  searchCtrl: string = "";
  isDocumentUploaded: boolean = false;  
  dupDocCols = ["Key", "Type"];
  deactivateUpload: boolean = false;
  fileLoading: boolean = false
  filterInput: string = ""
  allUsers = [];
  allGroups = [];
  allOwners = [];
  folders = [];
  selectedFolderName: any;
  selectedFolderId: any;
  selectedUser: string
  user: any;  
  userGroups: any[]
  multiparts: any[]
  isDjango: boolean
  stagingBucket: string;
  duplicateList = [];
  isUploadedSuccess = false;
  dupDocLength = 0;
  isDuplicateAvailable = false;
  isFileLimitExceed = false;
  fileLimit = 0;  
  noFolders:boolean = false;
  navBarFolders: any[];
  allVirtualFolders;
  documentCols: String[] = [];
  noDocuments: any;
  selectedRow: Array<JSON> = [];
  showDuplicateLink = false;
  displayDuplicateLabel = 'Show';
  teams: any;
  selectedTeamId: any;
  selectedTab: string = 'Folder';
  setFolderActive: boolean = true;
  myFilesCount:number = 0;

  pageSize = 50;
  pageIndex = 0;
  currentPageSize = 0;
  currentStartPageIndex = 0;
  totalDoc: number = 0;  

  constructor(
    private documentService: DocumentService,
    private usersAndGroupsService: UsersAndGroupsService,
    private groupService: UsersAndGroupsService,
    private authService: AuthenticationService,
    private alertService: AlertService,
    private config: AppConfig,
    private virtualFolderService: FileInboxVirtualFolderService,
    private migrationService: MigrationService,
    private httpClient: HttpClient
  ) {
    this.userGroups = this.authService.userGroupsValue;    
    this.isDjango = this.config.getConfig('isDjango');
  }

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.dupDocList && this.sort) {
      this.dupDocList.sort = this.sort;
    }
  }
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  private _transformer = (node: VirtualFolderNode, level: number) => {
    return {
      expandable: !!node.sub_folders && node.sub_folders.length > 0,
      id: node.id,
      folder_name: node.folder_name,
      level: level,
      parent_id: node.parent_id,
    };
  };
  treeControl = new FlatTreeControl<FolderFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.sub_folders
  );
  virtualFolders = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );
  hasChild = (_: number, node: FolderFlatNode) => node.expandable;

  duplicateSubList: any;

  @ViewChild(MatDrawerContainer) drawerContainer: MatDrawerContainer;  
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.dupDocList.paginator = this.paginator;
    }
  }

  ngOnInit() {
    let cacheFolderId = Number(localStorage.getItem('fileInboxFolderId'));
    if (cacheFolderId && cacheFolderId > 0) {
      this.selectedFolderId = cacheFolderId;
    }
    this.getVirtualFoldersTree();
    this.getTeamsTree();
    this.getMyFilesCount();
  }

  private getTeamsTree() {
    this.migrationService
      .getTeamsAll()
      .pipe(first())
      .subscribe((teams) => {
        for (let index in teams) {
          teams[index]['active'] = false;
          teams[index]['count'] = 0;
          this.getTeamCount(teams[index]);
        }
        this.teams = teams;
      });
  }

  private getMyFilesCount() {
    this.virtualFolderService
      .getVirtualFolderCount('duplicate', this.offset)
      .pipe(first())
      .subscribe((count) => {
        this.myFilesCount = count;
      });
  }

  async getTeamCount(team) {
    await this.virtualFolderService
      .getTeamDuplicate(team['id'], 0, this.offset)
      .pipe(first())
      .subscribe((resp) => {
        if (
          resp.Message ==
          'No records have been found matching the search criteria'
        ) {
          team['count'] = 0;
        } else {
          team['count'] = resp.count;
        }
      });
  }
  

  clickDuplicate(element) {
    this.selectedDoc = element['documentId'];
    this.showDuplicateLink = !this.showDuplicateLink;
    if (this.showDuplicateLink) {
      element['displayDuplicateLabel'] = 'Hide';
    } else {
      element['displayDuplicateLabel'] = 'Show';
    }
    this.showDuplicates(element);
  }

  showDuplicates(element) {
    let list = element['duplicate'];
    this.duplicateSubList = new MatTableDataSource(list);
  }

async getFlattenedVirtualFolders(){    
    this.allVirtualFolders= await this.virtualFolderService.getFlattenedTree();
    const folderStack = new Stack<number>();
    let isRootNode = false;      
    let id = this.selectedFolderId;
    if (this.allVirtualFolders && this.allVirtualFolders.length > 0) {
      while(!isRootNode) {
        let selectedFolder = this.allVirtualFolders.filter(folder => folder.id == id);
        if (selectedFolder && selectedFolder.length > 0) {            
          if (selectedFolder[0].parent_id == 0) {
            isRootNode = true;
          } else {
            folderStack.push(selectedFolder[0].parent_id);
            id = selectedFolder[0].parent_id;
          }
        } else {
          isRootNode = true;
        }
      }
      while(!folderStack.isEmpty()) {
        let id = folderStack.pop();
        let treeList = this.virtualFolders._expandedData.value.filter((node) => node.id == id);
        if (treeList.length > 0) {
            this.treeControl.expand(treeList[0]);                    
        }
      }
    }
    this.selectFolder(this.selectedFolderName, this.selectedFolderId);   
}

async getFlattenedVirtualTeamFolders(teamId){    
  this.allVirtualFolders= await this.virtualFolderService.getFlattenedFolderTree(teamId);  
  this.selectTeam(this.selectedFolderName, this.selectedFolderId);   
}

applyFilter() {  
  this.dupDocList.filter = this.filterInput.trim().toLowerCase();
  if (this.dupDocList.paginator) {
    this.dupDocList.paginator.firstPage();
    this.documentCount = this.dupDocList.filteredData.length;
  }  
}

refresh() { 
  this.getFlattenedVirtualFolders();
  this.getTeamsTree();
  this.getMyFilesCount();
}

acceptDuplicates() {
  let selectedList = this.selection.selected;
    let docIdsList = [];
    if (selectedList && selectedList.length > 0) {
      for (let index in selectedList) {
        docIdsList.push(selectedList[index]['documentId']);
      }
    }
    let request = {
      "document_ids": docIdsList,
      "status": "ACCEPT DUPLICATE"
    };
    this.migrationService.updateDuplicate(request).subscribe(resp => {
      if (resp && resp != 'Document not found in database') {                
        this.alertService.success("Updated successfully");
        setTimeout(() => {
          this.refresh();
        }, 2000);      
      } else{
        this.alertService.error("Document updation failed");
      }
    }, error => {
      this.alertService.error("Document updation failed");
    });
}

ignoreDuplicates() {
  let selectedList = this.selection.selected;
    let docIdsList = [];
    if (selectedList && selectedList.length > 0) {
      for (let index in selectedList) {
        docIdsList.push(selectedList[index]['documentId']);
      }
    }
    let request = {
      "document_ids": docIdsList,
      "status": "IGNORE DUPLICATE"
    };
    this.migrationService.updateDuplicate(request).subscribe(resp => {
      if (resp && resp != 'Document not found in database') {                
        this.alertService.success("Documents deleted successfully");
        setTimeout(() => {
          this.refresh();
        }, 2000);      
      } else{
        this.alertService.error("Document deletion failed");
      }
    }, error => {
      this.alertService.error("Document deletion failed");
    });
}

stringContainsAny(str: string, substrings: string[]): boolean {
  let strArray = str.split(".");
  let extension = '';
  if (strArray.length > 1) {
    extension = '.'+strArray[strArray.length - 1];
  }
  return substrings.some(substring => extension.includes(substring));
}

viewDocument(doc) {
  //console.log("doc id " + this.documentID);
  const msOfficeFiles = [".doc", ".docx", ".xls", ".xlsx", ".csv", ".ppt", ".pptx", ".dotx", ".dotm",".docm", ".xlsb", ".xlam", ".pst", ".rtf"];
  var storageKey = doc["storageKey"];
  const result = this.stringContainsAny(doc.documentName, msOfficeFiles);
  if (result) {
      if (storageKey.startsWith("upload/")) {
        this.documentService.viewDocument(doc.documentId)
          .subscribe(
            resp => {
              var url = resp.slice(5);
              this.httpClient.get(url, { responseType: 'blob' })
              .subscribe(blob => {
                saveAs(blob, doc.documentName);
              });
            }
          );
      } else {
        this.documentService.viewCaptureDocument(doc.documentId)
          .subscribe(
            resp => {
              var url = resp.slice(5);
              this.httpClient.get(url, { responseType: 'blob' })
              .subscribe(blob => {
                saveAs(blob, doc.documentName);
              });
            }
          );
      }

  } else {
    if (storageKey.startsWith("upload/")) {
      this.documentService.viewDocument(doc.documentId)
        .subscribe(
          resp => {
            //console.log("View document " + resp);
            var url = resp.slice(5);
            //window.open(url);
            window.open(url, '_blank', 'location=yes,height=900,width=900,scrollbars=yes,status=yes');
          }
        );
    } else {
      this.documentService.viewCaptureDocument(doc.documentId)
        .subscribe(
          resp => {
            //console.log("View document " + resp);
            var url = resp.slice(5);
            //window.open(url);
            window.open(url, '_blank', 'location=yes,height=900,width=900,scrollbars=yes,status=yes');
          }
        );
    }
  }  
  
}

private getVirtualFoldersTree() {
  this.virtualFolderService
    .getTree()
    .pipe(first())
    .subscribe((folders) => {
      if(folders.length == 0){
        this.noFolders = true          
      } else {
        if (this.selectedFolderId > 0) {
          let selectedFolderList = folders.filter((folder) => folder.id === this.selectedFolderId);
          if (selectedFolderList.length > 0) {
            this.selectedFolderName = selectedFolderList[0]['folder_name'];
          }
        } else {
          this.selectedFolderName = folders[0]['folder_name'];
          this.selectedFolderId = folders[0]['id'];          
        }         
        this.noFolders = false
        this.virtualFolders.data = folders;
        this.folders = folders;          
        this.navBarFolders = folders;
        this.navBarFolders.sort = this.sort; 
        this.getFlattenedVirtualFolders();          
      }
    });
}

onFolderSelect() {
  this.selectedTab = 'Folder';
  this.setFolderActive = !this.setFolderActive;
  for (let index in this.teams) {
    this.teams[index]['active'] = false;
  }
  if (this.setFolderActive) {
    this.getVirtualFoldersTree();
  }
}

onTeamSelect(team) {
  this.selectedTab = 'Team';
  let teamId = team.id;
  this.selectedTeamId = teamId;
  team.active = !team.active;
  for (let index in this.teams) {
    if (this.teams[index].id != team.id) {
      this.teams[index]['active'] = false;
    }
  }
  this.setFolderActive = false;
  if (team.active) {
    this.virtualFolderService
      .getFolderTree(teamId)
      .pipe(first())
      .subscribe((folders) => {
        if(folders.length == 0){
          this.noFolders = true          
        } else {
          this.selectedFolderName = folders[0]['folder_name'];
          this.selectedFolderId = folders[0]['id'];          
          this.noFolders = false
          this.virtualFolders.data = folders;
          this.folders = folders;          
          this.navBarFolders = folders;
          this.navBarFolders.sort = this.sort; 
          this.getFlattenedVirtualTeamFolders(teamId);         
        }
      });
  }
}

  checkboxLabel(row?: any): string {
    //this.docIdArray = true
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row 
    ${row.position + 1}`;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dupDocList.data.length;
    return numSelected === numRows;
  }

  selectPage(pageOptions) {
    this.pageIndex = pageOptions.pageIndex;
    this.pageSize = pageOptions.pageSize;
    let currentPageSize = this.pageSize;    
    this.currentStartPageIndex = (this.pageIndex * this.pageSize) + 1;
    currentPageSize = currentPageSize * (this.pageIndex + 1);
    if (currentPageSize >= this.documentCount && currentPageSize < this.totalDocumentCount) {
      this.offset += 200;
      if (this.selectedTab === "Folder") {
        this.selectFolderPagination(this.selectedFolderName, this.selectedFolderId);
      } else {
        this.selectTeamPagination(this.selectedFolderName, this.selectedFolderId);
      }
    }
    this.currentPageSize = currentPageSize;
  }

  selectFolder(name, id) {  
    this.selection.clear();
    this.noDocuments = true;
    this.selectedFolderName = name;
    this.selectedFolderId = id;
    this.documentCols = [      
      'select',
      'documentName',
      'filesize',
      'duplicates'
    ];
    this.virtualFolderService.getDuplicate(id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents.Message ==
        'No records have been found matching the search criteria'
      ) {
        this.noDocuments = true;
        this.totalDocumentCount = 0;
      } else {
        this.noDocuments = false;
        this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount = this.documents.results.length;
        //Get dynamic document columns
        // var categoryKeys = documents['results'][0];
        // var additionalCols: String[] = [];
        // Object.keys(categoryKeys).forEach(function (key) {
        //   if (key.startsWith('display_')) {
        //     additionalCols.push(key);
        //   }
        // });

        // for (var i = 0; i < additionalCols.length; i++) {
        //   this.documentCols.push(additionalCols[i]);
        // }
        this.documentCols.push("display_Water Right ID");
        // Sort documents by documentName in ascending order (A-Z)
        this.documents.results.sort((a, b) => {
          const nameA = (a.documentName || '').toLowerCase();
          const nameB = (b.documentName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.dupDocList = new MatTableDataSource(this.documents.results);
        this.dupDocList.sort = this.sort;
        this.dupDocList.paginator = this.paginator;
      }
      localStorage.setItem('fileInboxFolderId', this.selectedFolderId);
    });
  }

  selectFolderPagination(name, id) {
    this.selection.clear();    
    this.selectedFolderName = name;
    this.selectedFolderId = id;
    this.documentCols = [      
      'select',
      'documentName',
      'filesize',
      'duplicates'
    ];
    this.virtualFolderService.getDuplicate(id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents.Message ==
        'No records have been found matching the search criteria'
      ) {
        // this.noDocuments = true;
        // this.totalDocumentCount = 0;
      } else {
        this.noDocuments = false;
        //this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount += documents.results.length;
        //Get dynamic document columns
        // var categoryKeys = documents['results'][0];
        // var additionalCols: String[] = [];
        // Object.keys(categoryKeys).forEach(function (key) {
        //   if (key.startsWith('display_')) {
        //     additionalCols.push(key);
        //   }
        // });

        // for (var i = 0; i < additionalCols.length; i++) {
        //   this.documentCols.push(additionalCols[i]);
        // }
        this.documentCols.push("display_Water Right ID");
        documents.results.forEach(element => {
          this.documents.results.push(element);
        });
        // Sort documents by documentName in ascending order (A-Z)
        this.documents.results.sort((a, b) => {
          const nameA = (a.documentName || '').toLowerCase();
          const nameB = (b.documentName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.dupDocList = new MatTableDataSource(this.documents.results);
        this.dupDocList.sort = this.sort;
        this.dupDocList.paginator = this.paginator;
      }
    });
  }
  

  selectTeam(name, id) {  
    this.selection.clear();
    this.noDocuments = true;
    this.selectedFolderName = name;
    this.selectedFolderId = id;
    this.documentCols = [      
      'select',
      'documentName',
      'filesize',
      'duplicates'
    ];
    this.virtualFolderService.getTeamDuplicate(this.selectedTeamId, id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents.Message ==
        'No records have been found matching the search criteria'
      ) {
        this.noDocuments = true;
        this.totalDocumentCount = 0;
      } else {
        this.noDocuments = false;
        this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount = this.documents.results.length;
        //Get dynamic document columns
        // var categoryKeys = documents['results'][0];
        // var additionalCols: String[] = [];
        // Object.keys(categoryKeys).forEach(function (key) {
        //   if (key.startsWith('display_')) {
        //     additionalCols.push(key);
        //   }
        // });

        // for (var i = 0; i < additionalCols.length; i++) {
        //   this.documentCols.push(additionalCols[i]);
        // }
        this.documentCols.push("display_Water Right ID");
        // Sort documents by documentName in ascending order (A-Z)
        this.documents.results.sort((a, b) => {
          const nameA = (a.documentName || '').toLowerCase();
          const nameB = (b.documentName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.dupDocList = new MatTableDataSource(this.documents.results);
        this.dupDocList.sort = this.sort;
        this.dupDocList.paginator = this.paginator;
      }
    });
  }

  selectTeamPagination(name, id) {  
    this.selection.clear();    
    this.selectedFolderName = name;
    this.selectedFolderId = id;
    this.documentCols = [      
      'select',
      'documentName',
      'filesize',
      'duplicates'
    ];
    this.virtualFolderService.getTeamDuplicate(this.selectedTeamId, id, this.offset).subscribe((documents) => {
      this.folderSelected = true;
      if (
        documents.Message ==
        'No records have been found matching the search criteria'
      ) {
        //this.noDocuments = true;
        //this.totalDocumentCount = 0;
      } else {
        this.noDocuments = false;
        // this.documents = documents;
        this.totalDocumentCount = documents.count;
        if (this.totalDocumentCount > this.offset + 200) {
          this.loadNext = true;
        }
        if (this.offset >= 200) {
          this.loadPrevious = true;
        }
        this.documentCount += documents.results.length;
        //Get dynamic document columns
        // var categoryKeys = documents['results'][0];
        // var additionalCols: String[] = [];
        // Object.keys(categoryKeys).forEach(function (key) {
        //   if (key.startsWith('display_')) {
        //     additionalCols.push(key);
        //   }
        // });

        // for (var i = 0; i < additionalCols.length; i++) {
        //   this.documentCols.push(additionalCols[i]);
        // }
        this.documentCols.push("display_Water Right ID");
        documents.results.forEach(element => {
          this.documents.results.push(element);
        });
        // Sort documents by documentName in ascending order (A-Z)
        this.documents.results.sort((a, b) => {
          const nameA = (a.documentName || '').toLowerCase();
          const nameB = (b.documentName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.dupDocList = new MatTableDataSource(this.documents.results);
        this.dupDocList.sort = this.sort;
        this.dupDocList.paginator = this.paginator;
      }
    });
  }

}
